// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"fa80a86b","411":"655ff73b","790":"42a1150e"}[chunkId] + ".chunk.js";
};